<template>
  <pt-sign-notes-form class="pt-sign-notes-form__page" :isEdit="is_edit" :id="id" :noteId="noteId"></pt-sign-notes-form>
</template>

<script>
import PtSignNotesForm from 'cps/appointment-application/pt-sign-notes-form'
export default {
  name: 'pt-sign-notes-form__view',
  components: {
    'pt-sign-notes-form': PtSignNotesForm
  },
  props: {
    isEdit: {
      type: String
    },
    id: {
      type: String
    },
    noteId: {
      type: String
    }
  },
  data () {
    return {
      is_edit: !!this.isEdit
    }
  }
}
</script>
